const reducer = (state = [], action) => {
  switch (action.type) {
    case "FETCH_SOURCE_TYPE":
      return action.payload;
    case "ADD_SOURCE_TYPE":
      return [...state, action.payload];
    case "UPDATE_SOURCE_TYPE":
      return state.map((item) =>
        item.id === action.payload.id ? { ...action.payload } : item
      );
    case "REMOVE_SOURCE_TYPE":
      return state.filter((s) => s.id !== action.payload);
    case "CLEAR_SOURCE_TYPE":
      return [];
    default:
      return state;
  }
};
export default reducer;
